import { render, staticRenderFns } from "./AlbumNewPage.vue?vue&type=template&id=1e6fa2ee&lang=pug&"
import script from "./AlbumNewPage.vue?vue&type=script&lang=js&"
export * from "./AlbumNewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports